"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reducer = _interopRequireDefault(require("./reducer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
} // This combines React's `context` with the `useReducer` hook to implement global app state.
// We export one function that is used to
// (1) create an AppStateProvider, which is React Context API Provider
// (2) `useAppState` which is a custom hook that can be used to access app state in functional components
// (3) `AppStateConsumer` which is a React Context API Consuemer for accessing state in class-based components


var createAppState = function createAppState(rawReducer, initialState) {
  // `bundleReducer` will combine the reducer objects and insitialState 
  // and pass them to the React `useReducer` hook. It will also check for 
  // any "middleware" functions that need to be run when app state is updated  
  var reducer = (0, _reducer["default"])(rawReducer); // Set up a React `context` instance to hold our app state.
  // We're making the default value equal to the apps initialState

  var AppState = (0, _react.createContext)([initialState]); // Define the top-level wrapper component that provides this context. This should wrap the
  // entire app. In Gatsby, we need to use this component in gatsby-browser.js as we don't otherwise 
  // have access to the top-level component in our app.

  var AppStateProvider = function AppStateProvider(_ref) {
    var children = _ref.children;
    return _react["default"].createElement(AppState.Provider, {
      value: (0, _react.useReducer)(reducer, initialState)
    }, children);
  };

  var AppStateConsumer = AppState.Consumer; // Create a custom hook which is just a wrapper for the `useContext` hook 
  // that specifically loads the AppState

  var useAppState = function useAppState() {
    return (0, _react.useContext)(AppState);
  };

  return {
    AppStateProvider: AppStateProvider,
    AppStateConsumer: AppStateConsumer,
    useAppState: useAppState
  };
};

var _default = createAppState;
exports["default"] = _default;